import { Grid } from '@mui/material'
import FleetHomeView from '../Analytics/Dashboard/components/TabView/Views/FleetHomeView'
import FleetHomeViewWithMongo from '../Analytics/Dashboard/components/TabView/Views/FleetHomeViewWithMongo'

const Home = () => {
    return (
        <Grid
            container
            spacing={2}
            sx={{ marginTop: 10, marginLeft: 1, marginRight: 3 }}
        >
            {/* <FleetHomeViewWithMongo /> */}
            <FleetHomeView />
        </Grid>
    )
}

export default Home
